var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeOperation48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad",
    "data-name": "Dark Blue Grad",
    x1: 2.039,
    y1: 25.414,
    x2: 23.219,
    y2: 31.175,
    gradientTransform: "translate(16.57 -3.305) rotate(29.786)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#73b4c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#6aaec3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#529eb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#2c839f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#147391"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad-2",
    x1: 27.731,
    y1: 27.698,
    x2: 43.267,
    y2: 43.234,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Dark_Blue_Grad"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Dark_Blue_Grad-3",
    x1: 22.731,
    y1: 4.696,
    x2: 38.267,
    y2: 20.232,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#Dark_Blue_Grad"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient",
    "data-name": "paper gradient",
    x1: 28.38,
    y1: 10.38,
    x2: 32.62,
    y2: 14.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221,
    stopColor: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bebebe"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient-2",
    x1: 9.743,
    y1: 27.473,
    x2: 15.533,
    y2: 29.048,
    gradientTransform: "translate(41.761 14.862) rotate(90)",
    xlinkHref: "#paper_gradient"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paper_gradient-3",
    x1: 33.38,
    y1: 33.381,
    x2: 37.621,
    y2: 37.622,
    xlinkHref: "#paper_gradient"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.528,33.463l3.838.694,1.364-2.383-2.542-2.958a.436.436,0,0,1,.076-.651l3.2-2.221-.721-2.649L19.858,23a.439.439,0,0,1-.4-.51l.685-3.822L17.755,17.3l-2.948,2.526a.446.446,0,0,1-.643-.092l-2.221-3.2-2.65.721L9,21.141a.441.441,0,0,1-.522.4l-3.838-.693L3.272,23.227l2.542,2.958a.437.437,0,0,1-.077.652l-3.2,2.222.72,2.651,3.88.3a.442.442,0,0,1,.39.534l-.7,3.854L9.21,37.761,12.176,35.2a.43.43,0,0,1,.661.06l2.221,3.2,2.65-.72.3-3.881A.44.44,0,0,1,18.528,33.463Z",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.825,38.142l3.675-1.3V34.092l-3.675-1.3a.436.436,0,0,1-.257-.6l1.671-3.515L42.3,26.728,38.781,28.4a.439.439,0,0,1-.6-.242l-1.3-3.657H34.127l-1.3,3.657a.446.446,0,0,1-.6.239L28.7,26.726l-1.942,1.942,1.67,3.516a.441.441,0,0,1-.256.6l-3.675,1.3v2.746l3.675,1.3a.437.437,0,0,1,.257.6l-1.671,3.517L28.7,44.206l3.515-1.668a.442.442,0,0,1,.6.269l1.3,3.694h2.746l1.3-3.694a.43.43,0,0,1,.6-.276L42.3,44.2l1.942-1.942-1.67-3.516A.44.44,0,0,1,42.825,38.142Z",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.825,15.141l3.675-1.3V11.09l-3.675-1.3a.436.436,0,0,1-.257-.6l1.671-3.515L37.3,3.726,33.781,5.4a.439.439,0,0,1-.6-.242L31.873,1.5H29.127l-1.3,3.657a.446.446,0,0,1-.6.239L23.7,3.725,21.761,5.667l1.67,3.516a.441.441,0,0,1-.256.6L19.5,11.09v2.746l3.675,1.3a.437.437,0,0,1,.257.6l-1.671,3.517L23.7,21.2l3.515-1.668a.442.442,0,0,1,.6.269l1.3,3.694h2.746l1.3-3.694a.43.43,0,0,1,.6-.276L37.3,21.2l1.942-1.942-1.67-3.516A.44.44,0,0,1,37.825,15.141Z",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#Dark_Blue_Grad-3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 12.5,
    r: 3,
    stroke: "#464646",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 27.5,
    r: 3,
    transform: "translate(-17.073 25.556) rotate(-60.214)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient-2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.501,
    r: 3,
    stroke: "#464646",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    fill: "url(#paper_gradient-3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOperation48);
export default __webpack_public_path__ + "static/media/typeOperation48.969d146eb21e7781d9c985d83d88167e.svg";
export { ForwardRef as ReactComponent };